import { render, staticRenderFns } from "./PurchasedTicket.vue?vue&type=template&id=0fed21d4"
import script from "./PurchasedTicket.vue?vue&type=script&lang=ts"
export * from "./PurchasedTicket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports